import { getCurrentLanguage, getCurrentUnitSystem } from 'harmony-language';
import { getTimezone } from './date-time-utils';
import axios from 'axios';

export const downloadBillsOfLading = (orderIds) => {
    const language = getCurrentLanguage();
    const units = getCurrentUnitSystem();
    const timezone = getTimezone();

    window.location.href = `${API_BASE}/api/orders/bill-of-lading?orderIds=[${orderIds}]&language=${language}&units=${units}&timezone=${timezone}`;
};

export const downloadDeliveryTickets = (orderIds, weightSystem) => {
    const url = `${API_BASE}/api/orders/delivery-tickets`;

    let params = new URLSearchParams(url.search);
    params.set('language', getCurrentLanguage());
    params.set('timezone', getTimezone());
    params.set('units', getCurrentUnitSystem());
    params.set('unitsWeight', weightSystem);
    params.set('orderIds', `[${orderIds}]`);

    window.location.href = `${url}?${params.toString()}`;
}

export const downloadDailyReport = (reportDate, organizationId, resourceType, resourceId) => {
    const language = getCurrentLanguage();
    const units = getCurrentUnitSystem();
    const timezone = getTimezone();
    const resourceQuery = (resourceType && resourceId) ? `&resourceType=${resourceType}&resourceIds=[${resourceId}]` : '';

    window.location.href = `${API_BASE}/api/organizations/${organizationId}/daily-reports?language=${language}&units=${units}&timezone=${timezone}&date=${reportDate}${resourceQuery}`;
};

export const downloadResourceReport = (organizationId, dateBegin, dateEnd, resourceType, resourceId, weightSystem) => {
    const url = new URL(`${API_BASE}/api/organizations/${organizationId}/resource-reports`);
    let params = new URLSearchParams(url.search);
    params.set('language', getCurrentLanguage());
    params.set('units', getCurrentUnitSystem());
    params.set('timezone', getTimezone());
    params.set('unitsWeight', weightSystem);
    params.set('dateBegin', dateBegin);
    params.set('dateEnd', dateEnd);
    params.set('resourceType', resourceType);
    params.set('resourceId', resourceId);

    window.location.href = `${url.toString()}?${params.toString()}`;
};

export const downloadLoadsCSV = async (organizationId, weightSystem, loadIds, isLoading) => {
    const url = new URL(`${API_BASE}/api/organizations/${organizationId}/loads-csv-export`);
    let params = new URLSearchParams(url.search);
    params.set('language', getCurrentLanguage());
    params.set('units', getCurrentUnitSystem());
    params.set('timezone', getTimezone());
    params.set('unitsWeight', weightSystem);

    // We need to make a post and manually download the file
    // because the number of loadIds can be large and exceed URL length limits
    const response = (await axios.post(`${url.toString()}?${params.toString()}`, { loadIds: loadIds })).data;

    const blob = new Blob([response], { type: 'text/csv' });
    const a = document.createElement('a');
    a.download = 'LoadsExport.csv';
    a.href = window.URL.createObjectURL(blob);
    const clickEvt = new MouseEvent('click', {
        view: window,
        bubbles: true,
        cancelable: true,
    });
    a.dispatchEvent(clickEvt);
    a.remove();
    isLoading(false);
}
